// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"restaurants_mapContainer__as7JY","title":"restaurants_title__GZfoC"};